const transitions = {
    duration: {
        fast: '100ms',
        slow: '300ms',
    },
};

export { transitions as default };
//# sourceMappingURL=transition.js.map
